module.exports = __webpack_public_path__ + "static/media/minus.6d4fa7be.svg";